<template>
  <ul
    class="tags reset container flex flex-wrap justify-center w-full mt-xl mb-2xl mx-auto md:mt-lg md:mb-0 md:pb-2xl"
  >
    <li
      v-for="(category, index) in productCategories"
      :key="category + index"
      class="tag mr-sm mb-md py-sm px-md bg-gray-900 c-white text-sm rounded-sm"
    >
      <span v-html="category"></span>
    </li>
    <li
      v-for="(color, index) in colors"
      :key="color + index"
      class="tag mr-sm mb-md py-sm px-md bg-gray-900 c-white text-sm rounded-sm"
    >
      <span v-html="color"></span>
    </li>
    <li
      v-for="(finish, index) in finishes"
      :key="finish + index"
      class="tag mr-sm mb-md py-sm px-md bg-gray-900 c-white text-sm rounded-sm"
    >
      <span v-html="finish"></span>
    </li>
    <li
      v-for="(material, index) in materials"
      :key="material + index"
      class="tag mr-sm mb-md py-sm px-md bg-gray-900 c-white text-sm rounded-sm"
    >
      <span v-html="material"></span>
    </li>
  </ul>
</template>

<script>
const normalizeArray = val => (Array.isArray(val) ? val : [val]);

export default {
  props: {
    item: {type: Object, required: true}
  },

  computed: {
    productCategories() {
      return normalizeArray(this.item.product_category);
    },
    finishes() {
      return normalizeArray(this.item.finish);
    },
    colors() {
      return normalizeArray(this.item.colors);
    },
    materials() {
      return normalizeArray(this.item.materials);
    }
  }
};
</script>

<style lang="scss" scoped>
.tags {
  max-width: 700px;
}
</style>
